import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Fab,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Send as SendIcon,
  Person as AccountIcon,
  ArrowBack as ArrowBackIcon,
  ExitToApp,
  QuestionAnswer,
  Settings,
  FullscreenExit,
  FullscreenOutlined,
  Print,
  HelpOutline,
  NotificationImportantSharp,
  PlusOne,
  AccountCircle,
  Widgets,
  Info,
} from "@mui/icons-material";
import classNames from "classnames";

import { Navbar, Nav, NavDropdown, Form, Row } from "react-bootstrap";
import { NavLink, Link, useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { signOut } from "utility/helpers";
import useStyles from "./styles";
import { Badge, Typography } from "../Wrappers";
import Notification from "../Notification/Notification";
import UserAvatar from "../UserAvatar/UserAvatar";
import InfoIcon from "@mui/icons-material/Info";
import SupervisedUserCircleIcon from "@mui/icons-material/SupervisedUserCircle";
import { isDesktop } from "react-device-detect";
import {
  DeskTopContainer,
  MobileContainer,
  useInMobile,
} from "../../themes/Device";
import { useTranslation, initReactI18next } from "react-i18next";

// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "context/LayoutContext";

import "assets/css/header.css";
import InfoModel from "components/InfoModel";
import { useTheme } from "@mui/material/styles";
import NavbarHorizontal from "components/Layouts/dashboard/navbar/NavbarHorizontal";
import RoleBasedGuard from "guards/RoleBasedGuard";
import { ACTION, RESOURCE } from "common/constant";
import ReactPlayer from "react-player";
import PopUpModel from "components/Popup/PopUpModel";
import Label from "components/Label";
import Avatar from "components/Avatar";
import CardAvatar from "components/Card/CardAvatar";
import configData from "config";

const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];
export default function Header(props) {
  var { classes } = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  const theme = useTheme();
  const orderHistoryDataList = useSelector(
    (state) => state?.api?.orderHistoryData,
  );
  const userInfo = useSelector((state) => state.user.userData);
  // useScript(`function googleTranslateElementInit() {
  //         new google.translate.TranslateElement({
  //           pageLanguage: 'en',
  //           includedLanguages: 'en,hi,gu,be,fr,ka,ma,ta,te'}, 'google_translate_element');
  //       }`);
  // useScript('//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit');

  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [quickAddMenu, setQuickAddMenu] = useState(null);
  const [fullscreen, setFullscreen] = useState(false);
  const [modalShow, setModalShow] = React.useState(false);
  const [videomodalShow, setVideomodalShow] = React.useState(false);
  const [orderNotification, setorderNotification] = useState([]);
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      document.documentElement.requestFullscreen();
      setFullscreen(true);
    } else if (document.exitFullscreen) {
      document.exitFullscreen();
      setFullscreen(false);
    }
  };

  // useEffec<t(>() => {
  //   SocketEndPoint.on("sendNotification", (payload) => {
  //     setorderNotification((pre) => [...pre, payload]);
  //   });
  // }, [SocketEndPoint]);

  const getScreenTitle = () => {
    const path = history.location.pathname;
    if (path === "/app/customer-queue") {
      return t("customer-queue-title");
    }
    return "";
  };

  return (
    <AppBar
      className={classes.appBar}
      style={{
        background: theme.palette.background.default,
        color: theme.palette.text.primary,
        padding: useInMobile() ? "4px" : "0px",
      }}
    >
      <PopUpModel
        size="lg"
        onHide={() => {
          setVideomodalShow(false);
        }}
        show={videomodalShow}
        heading={"Help Video"}
        body={
          <Row>
            <ReactPlayer
              controls
              style={{ paddingTop: "0px" }}
              width="800px"
              height="480px"
              onError={() => console.log("onError CallBack")}
              onPause={() => console.log("onPause CallBack")}
              onStart={() => console.log("onStart CallBack")}
              onReady={() => console.log("OnReady CallBack")}
              onEnded={() => console.log("onEnded CallBack")}
              url="http://commondatastorage.googleapis.com/gtv-videos-bucket/sample/ForBiggerBlazes.mp4"
            />
          </Row>
        }
      />
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => {
            if(!layoutState.isSidebarOpened) {
              toggleSidebar(layoutDispatch)
            }
          }}
          className={classNames(
            classes.headerMenuButtonSandwich,
            classes.headerMenuButtonCollapse,
          )}
          size="large">
          {layoutState.isSidebarOpened ? (
            <ArrowBackIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <Widgets
              style={{ color: theme.palette.primary.main,
              width: '1.2em',
              height: '1.2em' }}
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        {/* <Navbar.Brand className={`${classes.navBarLogo} mx-auto`}>
          <Link
            to={
              shopSettingListData.some(
                ({ key, value }) =>
                  key === "DINE_IN_SERVICE" && value === "true",
              )
                ? "/app/dine-in"
                : "/app/order/new"
            }
          >
            <img
              src={
                "https://servofeatproduction.s3.ap-south-1.amazonaws.com/logo512.png" ||
                servoFeatLogo
              }
              style={{ width: "37px" }}
            />
          </Link>
        </Navbar.Brand> */}
        <DeskTopContainer>
          <NavbarHorizontal />
        </DeskTopContainer>
        <MobileContainer>
          <div className={classes?.screenTitle}>
            {layoutState?.currentScreenTitle || getScreenTitle()}
          </div>
        </MobileContainer>
        <Navbar variant="light" expand="md" sticky="top" className="smr-navbar">
          {/* <DeskTopContainer>
            <Nav
              className={`${classes.mobileNavBar}`}
              variant="pills"
              defaultActiveKey="app/dine-in"
            >
              {structure.map((route, routeIndex) => {
                return (
                  !route?.isSidebar &&
                  (route?.children && route?.children?.length > 0 ? (
                    <NavDropdown
                      title={
                        <>
                          {route?.icon}{" "}
                          <span className="ml-1">{route?.label}</span>
                        </>
                      }
                      id={`basic-nav-dropdown-${route?.id}`}
                    >
                      {route?.children.map((childRoute, index) => (
                        <NavDropdown.Item
                          as={NavLink}
                          key={`nav-item-${index}`}
                          to={childRoute?.link}
                        >
                          {childRoute?.icon}{" "}
                          <span className="ml-1">{childRoute?.label}</span>
                        </NavDropdown.Item>
                      ))}
                    </NavDropdown>
                  ) : (
                    <ServiceEnabled
                      envVariableList={shopSettingListData}
                      serviceName={route?.serviceName}
                    >
                      <Nav.Item key={`nav-item-${routeIndex}`}>
                        <Nav.Link as={NavLink} to={route?.link}>
                          {route?.home ? (
                            <div style={{ padding: "4.8px 5px" }}>
                              {route?.icon}
                            </div>
                          ) : (
                            <span
                              style={{
                                marginTop: "0px",
                                fontSize: "15px",
                                justifyContent: "center",
                              }}
                            >
                              <span
                                style={{ fontSize: "20px", marginRight: "2px" }}
                              >
                                {route?.icon}
                              </span>
                              <DeskTopContainer>
                                {route?.label}
                              </DeskTopContainer>
                            </span>
                          )}
                        </Nav.Link>
                      </Nav.Item>
                    </ServiceEnabled>
                  ))
                );
              })}
            </Nav>
          </DeskTopContainer> */}

          <div className="d-flex ml-auto align-items-center">
            <DeskTopContainer>
              {/* {userInfo?.user?.is_trial && (
                <div className="pr-2">
                  <Label color="error">
                    {t("header-trail-day-label")}:{userInfo?.user?.trial_day}
                  </Label>
                </div>
              )}
              {Number(userInfo?.user?.number_of_order) !== -1 ? (
                <Label color="error">
                  {t("available-order")}: {userInfo?.user?.number_of_order}
                </Label>
              ) : null} */}

              {/* <Button
                variant="contained"
                onClick={() => props.history.push("/app/pricing")}
                startIcon={<LockIcon />}
                sx={{
                  backgroundColor: "#00AB55",
                  textTransform: "capitalize",
                  marginLeft: "8px",
                  fontSize: "10px",
                  padding: "4px 20px",
                }}
              >
                Upgrade Plan
              </Button> */}
              <IconButton
                className={classes.iconButton}
                onClick={() => setModalShow(true)}
                size="large">
                <InfoIcon classes={{ root: classes.phoneIcon }} />
              </IconButton>
              {/* <IconButton
                className={classes.iconButton}
                onClick={() => setVideomodalShow(true)}
              >
                <HelpIcon classes={{ root: classes.phoneIcon }} />
              </IconButton> */}

              {fullscreen ? (
                <IconButton className={classes.iconButton} onClick={toggleFullscreen} size="large">
                  <FullscreenOutlined
                    classes={{ root: classes.fullScreenIcon }}
                  />
                </IconButton>
              ) : (
                <IconButton className={classes.iconButton} onClick={toggleFullscreen} size="large">
                  <FullscreenExit classes={{ root: classes.fullScreenIcon }} />
                </IconButton>
              )}
              <IconButton
                aria-haspopup="true"
                className={classes.headerMenuButton}
                aria-controls="quickadd-menu"
                onClick={(e) => setQuickAddMenu(e.currentTarget)}
                size="large">
                <Label color="primary" variant='ghost'>
                  {`+ Quick Add`}
                </Label>
              </IconButton>  
              {userInfo?.user?.name &&
              <div style={{ marginLeft: "8px" }}>
                <Label color="success" variant='ghost'>
                  {`Welcome ${userInfo?.user?.name}`}
                </Label>
              </div>}
            </DeskTopContainer>
             

            {/* <ContactsPopover/> */}
            {/* <IconButton
              color="inherit"
              aria-haspopup="true"
              aria-controls="mail-menu"
              onClick={(e) => {
                setNotificationsMenu(e.currentTarget);
                // setIsNotificationsUnread(false);
              }}
              className={classes.headerMenuButton}
            >
              <Badge
                badgeContent={
                  orderNotification.length
                }
                color="primary"
              >
                <NotificationImportantSharp classes={{ root: classes.headerIcon }} />
              </Badge>
            </IconButton> */}
            <IconButton
              aria-haspopup="true"
              color="inherit"
              className={classes.headerMenuButton}
              aria-controls="profile-menu"
              onClick={(e) => setProfileMenu(e.currentTarget)}
              size="large">
              {(userInfo?.billing?.logo && userInfo?.billing?.logo != "") ?
                <CardAvatar>
                  <img
                    style={{
                      borderRadius: 40,
                      height: 40,
                      width: 40,
                      objectFit: "contain"
                    }}
                    src={configData?.S3_BUCKET + userInfo?.billing?.logo}
                    alt="brand logo"
                  />
                </CardAvatar>
                : <Avatar
                  src={userInfo?.billing?.logo}
                  alt={userInfo?.user?.name}
                  color={'primary'}
                >
                  {userInfo?.user?.name ? userInfo?.user?.name?.charAt(0)?.toUpperCase() : "S"}
                </Avatar>}
              {/* <AccountCircle classes={{ root: classes.headerIcon }} /> */}
            </IconButton>
            <InfoModel show={modalShow} onHide={() => setModalShow(false)} />
          </div>
        </Navbar>
        {/* <div className={classes.grow} /> */}
        {/* <div
          className={classNames(classes.search, {
            [classes.searchFocused]: isSearchOpen,
          })}
        >
          <div
            className={classNames(classes.searchIcon, {
              [classes.searchIconOpened]: isSearchOpen,
            })}
            onClick={() => setSearchOpen(!isSearchOpen)}
          >
            <SearchIcon classes={{ root: classes.headerIcon }} />
          </div>
          <InputBase
            placeholder="Search…"
            classes={{
              root: classes.inputRoot,
              input: classes.inputInput,
            }}
          />
        </div> */}
        <Menu
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              {t("header-new-message-label")}
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} {t("header-new-message-label")}
            </Typography>
          </div>
          {messages.map((message) => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))}
          <Fab
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        {orderNotification.length > 0 ? (
          <Menu
            id="notifications-menu"
            open={Boolean(notificationsMenu)}
            anchorEl={notificationsMenu}
            onClose={() => {
              setNotificationsMenu(null);
              setorderNotification([]);
            }}
            className={classes.headerMenu}
            disableAutoFocusItem
          >
            {orderNotification.map((notification) => (
              <MenuItem
                key={notification.id}
                onClick={() => {
                  setNotificationsMenu(null);
                  setorderNotification([]);
                }}
                className={classes.headerMenuItem}
              >
                <Notification {...notification} typographyVariant="inherit" />
              </MenuItem>
            ))}
          </Menu>
        ) : (
          <Menu
            id="notifications-menu"
            open={Boolean(notificationsMenu)}
            anchorEl={notificationsMenu}
            onClose={() => {
              setNotificationsMenu(null);
              setorderNotification([]);
            }}
            className={classes.headerMenu}
            disableAutoFocusItem
          >
            <MenuItem
              // key={notification.id}
              onClick={() => {
                setNotificationsMenu(null);
                setorderNotification([]);
              }}
              className={classes.headerMenuItem}
            >
              <Notification
                message="No any notification"
                typographyVariant="inherit"
              />
            </MenuItem>
          </Menu>
        )}
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => setProfileMenu(null)}
          onClick={() => setProfileMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <RoleBasedGuard resource={RESOURCE.PROFILE} action={ACTION.VIEW}>
            <NavLink to="/app/profile" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                <AccountIcon />
                &nbsp;{t("header-profile-label")}
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
              onClick={() => setModalShow(true)}
            >
              <QuestionAnswer />
              &nbsp;{t("header-support-label")}
          </MenuItem>
          <NavLink to="/app/help-videos" style={{ width: "100%" }}>
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
            >
              <HelpOutline />
              &nbsp;  Help Videos
            </MenuItem>
          </NavLink>
          <RoleBasedGuard resource={RESOURCE.ROLES} action={ACTION.VIEW}>
            <NavLink to="/app/roles" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                <SupervisedUserCircleIcon />
                &nbsp;{t("header-roles-label")}
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          {!isDesktop && (
            <>
            <NavLink to="/app/mobile-printer" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                <Print />
                &nbsp;{t("header-printer-label")}
              </MenuItem>
            </NavLink>
            <NavLink to="/app/about-app" style={{ width: "100%" }}>
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
            >
              <Info />
             About App
            </MenuItem>
          </NavLink>
          </>
          )}

          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
            onClick={() => signOut(props)}
          >
            <ExitToApp />
            &nbsp;{t("header-sign-out-label")}
          </MenuItem>
        </Menu>
        <Menu
          id="quickadd-menu"
          open={Boolean(quickAddMenu)}
          anchorEl={quickAddMenu}
          onClose={() => setQuickAddMenu(null)}
          onClick={() => setQuickAddMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <RoleBasedGuard
            resource={RESOURCE.DINE_IN_TABLE}
            action={ACTION.ADD}>
            <NavLink to="/app/dining-table" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Dining Table
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          <RoleBasedGuard
            resource={RESOURCE.FOOD_CATEGORY}
            action={ACTION.ADD}>
            <NavLink to="/app/food-category" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Food Category
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          <RoleBasedGuard
            resource={RESOURCE.FOOD_MENUS}
            action={ACTION.ADD}>
            <NavLink to="/app/food-menu" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Food Menu
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          <RoleBasedGuard
            resource={RESOURCE.INVENTORY}
            action={ACTION.ADD}>
            <NavLink to="/app/inventory" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Inventory
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          <RoleBasedGuard
            resource={RESOURCE.EXPENSE}
            action={ACTION.ADD}>
            <NavLink to="/app/expense" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Expense
              </MenuItem>
            </NavLink>
          </RoleBasedGuard>
          {/* <RoleBasedGuard
            resource={RESOURCE.ORDER_TYPE}
            action={ACTION.ADD}>
            <NavLink to="/app/ordertype" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Order Type
              </MenuItem>
            </NavLink>
          </RoleBasedGuard> */}
          {/* <RoleBasedGuard
            resource={RESOURCE.PAYMENT_TYPE}
            action={ACTION.ADD}>
            <NavLink to="/app/paymenttype" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Payment Type
              </MenuItem>
            </NavLink>
          </RoleBasedGuard> */}
          {/* <RoleBasedGuard
            resource={RESOURCE.COUPONS}
            action={ACTION.ADD}>
            <NavLink to="/app/coupons" style={{ width: "100%" }}>
              <MenuItem
                className={classNames(
                  classes.profileMenuItem,
                  classes.headerMenuItem,
                )}
              >
                Discount Coupons
              </MenuItem>
            </NavLink>
          </RoleBasedGuard> */}
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
